// extracted by mini-css-extract-plugin
export default {"navBox":"FooterNav_navBox__--Qhn","nav":"FooterNav_nav__JVE7e"};